module.exports = __webpack_public_path__ + "media/src/website/images/locations/muehldorf/muehldorf_05-bf5fff5282dbb7c76223440e5deae302.jpg";